<script>
import { mapGetters } from 'vuex';
import { ElAlert } from 'element-plus';

export default {
  components: {
    ElAlert,  // 注册 ElAlert 组件
  },

  emits: ['openNotificationPanel'],

  computed: {
    ...mapGetters({
      notificationMetadata: 'notifications/getMeta',
      notificationList: 'notifications/getNotifications',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },

    tipContent() {
      let tipContent = ""
      const item = this.notificationList.find(item => item?.primary_actor_type == "User" && !item?.read_at)
      if (item?.notification_type == "insufficient_gpt_balance") {
        tipContent = this.$t("NOTIFICATIONS_ALERT.INSUFFICIENT_GPT_BALANCE") 
      }
      if (item?.notification_type == "automatically_disable_gpt") {
        tipContent = this.$t("NOTIFICATIONS_ALERT.INTELLIGENT_CUSTOMER_SERVICE_IS_DISABLED") 
      }
      return tipContent;
    }
  },
  methods: {
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('openNotificationPanel');
      }
    },
    handleAlertClick() {
      this.$router.push({name: 'billing_settings_index'});
    }
  },
};
</script>

<template>
  <div>
    <!-- <div class="w-24 h-24 bg-red-500">9999999999999999</div> -->
    <div class="fixed top-0 left-0 z-50 w-screen">
      <ElAlert
        v-if="!!tipContent"
        :title="tipContent"
        @click="handleAlertClick"
        type="error"
        class="flex justify-center items-center text-center"
      />
    </div>
  <div class="mb-4">
    <button
      class="relative flex items-center justify-center w-10 h-10 p-0 my-2 rounded-lg text-slate-600 dark:text-slate-100 hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600"
      :class="{
        'bg-woot-50 dark:bg-slate-800 text-woot-500 hover:bg-woot-50':
          isNotificationPanelActive,
      }"
      @click="openNotificationPanel"
    >
      <fluent-icon
        icon="alert"
        :class="{
          'text-woot-500': isNotificationPanelActive,
        }"
      />
      <span
        v-if="unreadCount"
        class="text-black-900 bg-yellow-300 absolute -top-0.5 -right-1 text-xxs min-w-[1rem] rounded-full"
      >
        {{ unreadCount }}
      </span>
    </button>
  </div>
</div>
</template>
